export enum RouteRecSegmentType {
  Walk = 'Walk',
  Taxi = 'Taxi',
  PublicTransport = 'Public Transport',
  TaxiPublicTransport = 'Taxi, Public Transport',
  PublicTransportTaxi = 'Public Transport, Taxi',
  TaxiPublicTransportTaxi = 'Taxi, Public Transport, Taxi',
  DrivePublicTransport = 'Drive, Public Transport',
  PublicTransportDrive = 'Public Transport, Drive',
  Cycle = 'Cycle',
  Car = 'Car',
  CyclePublicTransport = 'Cycle, Public Transport',
  PublicTransportCycle = 'Public Transport, Cycle',
  CyclePublicTransportCycle = 'Cycle, Public Transport, Cycle',
}

export enum RouteRecSegmentPartType {
  Cycle = 'Cycle',
  Taxi = 'Taxi',
  Bus = 'Bus',
  Train = 'Train',
  Overground = 'Overground',
  Underground = 'Underground',
  Ferry = 'Ferry',
  Walk = 'Walk',
  Coach = 'Coach',
}
